import type {IconType} from '@Components/icon-v2/icon.types';

export interface NotificationButtonProps {
  onClick?: VoidFunction;
  className?: string;
  isActive?: boolean;
  buttonType: IconType;
}

export const NOTIFICATION_POLLING_INTERVAL = 30000;
